<template>
  <vue-final-modal
    v-slot="{ close }"
    v-bind="$attrs"
    classes="modal-container"
    content-class="modal-content"
    v-on="$listeners"
    :click-to-close="false"
  >
    <div class="modal__content p-4 md:p-4 text-center">
      <div class="modal__title heading text-4xl leading-11 text-dark mb-10">
        {{ $t('modal.reward-record.title') }}
      </div>
      <div v-loading="isLoading" element-loading-background="rgba(243, 244, 246, 1)">
        <div v-if="total === 0" class="min-h-[300px] flex justify-center items-center font-semibold">
          {{ $t('modal.reward-record.no-data') }}
        </div>
        <div v-else class="table-wrap min-h-[300px]">
          <el-table :data="data" :fit="true" style="width: 100%">
            <el-table-column prop="at" label="Date" align="left" width="160">
            </el-table-column>
            <el-table-column prop="type" label="Type" align="left" width="120">
            </el-table-column>
            <el-table-column prop="amount" label="Amount" align="left" min-width="160">
            </el-table-column>
          </el-table>
          <el-pagination :page-size="limit" :pager-count="5" layout="prev, pager, next" :total="total"
            :hide-on-single-page="true" @current-change="handlePageChange">
          </el-pagination>
        </div>
      </div>
    </div>
    <button class="modal__close" @click="close">
      <icon-close-popup />
    </button>
  </vue-final-modal>
</template>

<script>
import { VueFinalModal } from 'vue-final-modal'
import {
  queryRewardRecord
} from '@/utils/api/card'

export default {
  components: { VueFinalModal },
  name: 'RewardRecord',
  inheritAttrs: false,
  data () {
    return {
      data: [],
      skip: 0,
      limit: 10,
      total: 0,
      isLoading: true
    }
  },
  computed: {},
  created () {
    this.queryHistory()
  },
  methods: {
    async queryHistory () {
      this.isLoading = true
      const { limit, skip } = this
      const params = {
        limit,
        skip
      }
      const response = await queryRewardRecord(params)
      const { items, total } = response
      this.total = total
      this.data = items
      this.isLoading = false
    },
    handlePageChange (page) {
      this.skip = (page - 1) * this.limit
      this.queryHistory()
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
